import React from 'react'
import cntl from 'cntl'
import { prepareData } from 'utils/googleData'


export const SectionWrapper = ({ children, className = '',direction }) => {
    return (
        <section  direction={direction} className={`${className} mb-12 mt-12 md:px-4`}>
            <div  direction={direction}>{children}</div>
        </section>
    )
}
const sizes = {
    md: {
        quote: cntl`
            md:text-[24px]
            md:leading-[33.6px]
            m-0
        `,
        name: cntl`
            md:text-[20px]
            md:leading-[21.88px]
        `,
        title: cntl`
            md:text-[18px]
        `,
        image: cntl`
            w-[80px]
            h-[80px]
        `,
        footer: cntl`
            mt-[20px]
            space-x-[14px]
        `,
    },
    lg: {
        quote: cntl`
            md:text-[32px]
            md:leading-[48px]
        `,
        name: cntl`
            md:text-xl
        `,
        title: cntl`
            md:text-lg
        `,
        image: cntl`
            w-[100px]
            h-[100px]
        `,
        footer: cntl`
            space-x-8
            mt-9
        `,
    },
}

const base = {
    quote: cntl`
        text-xl
        text-primary
        dark:text-primary-dark
        m-0
        quote
    `,
    name: cntl`
        not-italic
        text-lg
    `,
    title: cntl`
        not-italic
        text-lg
        opacity-50
    `,
    footer: cntl`
        flex
        items-center
    `,
    section: cntl`
        !max-w-screen-lg
        mx-auto
        text-primary
        font-bold
    `,
    image: cntl`
        rounded-full
    `,
}

const classes = (type, size = 'lg', className = '') => cntl`
    ${base[type]}
    ${sizes[size][type]}
    ${className}
`
export default function HomeQuote(props)  {
            const {enable,title,name,description,cta,direction,style='',gatsbyImage,gatsbyImage2,text,gatsbyImageSrc,gatsbyImage2Src, size = 'lg',}= prepareData({props})
           if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

    return (
            <SectionWrapper direction={direction} className={classes('section', size, style)}>
                <div  direction={direction}>
                    {gatsbyImage2Src && <img  dclassName="mb-9" src={gatsbyImage2Src} />}
                    <blockquote   className={classes('quote', size)}>
                        {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
                        <footer  className={classes('footer', size)}>
                            {gatsbyImageSrc && (
                                <img
                                    className={classes('image', size)}
                                    width={100}
                                    height={100}
                                    placeholder="none"
                                    alt={`${name} ${title}, ${description}`}
                                    src={gatsbyImageSrc}
                                />

                            )}
                            <span  className="flex flex-col">
                                {name && <cite className={classes('name', size)}>{name }</cite>}
                                {title && description && (
                                    <cite className={classes('title', size)}>
                                        {' '}
                                        {title }, {description}
                                    </cite>
                                )}
                            </span>
                        </footer>
                    </blockquote>
                </div>
            </SectionWrapper>

    )
        }
